import { render, staticRenderFns } from "./ExtensionEditDialog.vue?vue&type=template&id=0489c4b4&scoped=true&"
import script from "./ExtensionEditDialog.vue?vue&type=script&lang=js&"
export * from "./ExtensionEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionEditDialog.vue?vue&type=style&index=0&id=0489c4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489c4b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VCard,VDialog,VIcon,VProgressCircular,VSelect,VTextField})
